<template>
    <div id="data-list-list-view" class="data-list-container">
        <ContractDetails
                :isSidebarActive="showSidebar"
                :data="sidebarData"
                @closeSidebar="toggleSidebar"
                :services="services"
                :getContracts="getContracts"
        />
        <vs-table
                ref="table"
                pagination
                :max-items="itemsPerPage"
                search
                :data="contracts"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Ajouter un contrat</vs-button>
                </div>
            </div>
            <template slot="thead">
                <vs-th sort-key="code">Code</vs-th>
                <vs-th sort-key="start">Date de début</vs-th>
                <vs-th sort-key="end">Date de fin</vs-th>
                <vs-th sort-key="signature">Signé le</vs-th>
                <vs-th sort-key="status">Statut</vs-th>
                <vs-th sort-key="services">Services</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <span class="font-semibold">
                                {{ tr.code_contract }}
                                <span v-if="tr.default_contract" class="ml-2 font-normal">(Par défaut)</span>
                            </span>
                        </vs-td>
                        <vs-td><span>{{ tr.date_debut }}</span></vs-td>
                        <vs-td><span>{{ tr.date_fin }}</span></vs-td>
                        <vs-td><span>{{ tr.signer_le }}</span></vs-td>
                        <vs-td>
                            <vs-chip :color="tr.status == '1' ? 'success' : 'danger'">{{ tr.status == '1' ? 'Actif' : '' }}</vs-chip>
                        </vs-td>
                        <vs-td><span>{{ tr.service ? tr.service.length : 0 }}</span></vs-td>
                        <vs-td>
                            <div class="flex">
                                <vx-tooltip text="Modifier">
                                    <feather-icon @click="editData(tr)"
                                            icon="EditIcon"
                                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                            class="mr-2"
                                    />
                                </vx-tooltip>
                                <vx-tooltip text="Supprimer">
                                    <feather-icon @click="deleteContract(tr)" v-if="!tr.default_contract"
                                            icon="TrashIcon"
                                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                            class="mr-2"
                                    />
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>

        </vs-table>
    </div>
</template>

<script>
    import ContractDetails from "./ContractDetails";
    export default {
        components: {ContractDetails},
        props:{
          contracts:{
            type: Array,
          },
          getContracts: {
            type: Function
          }
        },
        data() {
            return {
                itemsPerPage: 8,
                isMounted: false,
                selected: [],
                showSidebar: false,
                sidebarData: {},
              services: []
            }
        },
        computed: {

        },
        mounted() {
            this.isMounted = true;
        },
        methods: {
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            addNewData() {
                this.sidebarData = {};
                this.getService()
                this.toggleSidebar(true);
            },
            editData(data) {
                this.sidebarData = {...data}
                this.getService()
                this.toggleSidebar(true);
            },
          getService(){
            this.$vs.loading()
            this.$http.get('/services/list').then((response) =>{
              this.services = response.data
              this.$vs.loading.close()
            }).catch((error) => {
              this.$vs.loading.close()
            })
          },
          deleteContract(tr){
            if (confirm('Voulez vous supprimer ce contrat ?')){
              this.$vs.loading()
              this.$http.post('/contracts/remove',
                {id: tr.id}
              ).then((re) => {
                if (!re.data.status){
                  window.GETCCMT.error({ message: "Une erreur est survenu lors de l'opération" });
                }else {
                  let index = this.contracts.indexOf(tr)
                  this.contracts.splice(index, 1)
                }
                this.$vs.loading.close()
              }).catch((error) => {
                console.log(error)
                this.$vs.loading.close()
              })
            }
          },
        },
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
